module.exports = __webpack_public_path__ + "img/76_24.c94214d1.png";